import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { FaClock, FaCheckCircle, FaShieldAlt, FaLock } from 'react-icons/fa';
import { trackEvent } from '../utils/tracking';

const Checkout = () => {
  const [timeLeft, setTimeLeft] = useState({ hours: 2, minutes: 47, seconds: 35 });

  useEffect(() => {
    // Track AddToCart when page loads
    trackEvent('AddToCart', {
      content_ids: ['news-hack-webinar'],
      content_type: 'product',
      value: 100000,
      currency: 'IDR'
    });

    // Timer countdown
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return { ...prev, seconds: prev.seconds - 1 };
        } else if (prev.minutes > 0) {
          return { ...prev, minutes: prev.minutes - 1, seconds: 59 };
        } else if (prev.hours > 0) {
          return { ...prev, hours: prev.hours - 1, minutes: 59, seconds: 59 };
        }
        return prev;
      });
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  // Setup tracking for button clicks
  useEffect(() => {
    // Track clicks on elements with class btn-complete-order or similar
    document.addEventListener("click", function(event) {
      // Check for OrderOnline submit button by class or parent elements
      if (event.target.closest(".btn-complete-order") || 
          event.target.closest(".oo-btn-submit") ||
          event.target.closest(".oo-submit") ||
          event.target.closest("button[type='submit']") ||
          (event.target.tagName === "BUTTON" && event.target.textContent.includes("Selesaikan"))) {
        
        console.log("✅ Checkout button clicked!");

        trackEvent('InitiateCheckout', {
          content_ids: ['news-hack-webinar'],
          content_type: 'product',
          value: 100000,
          currency: 'IDR'
        });
      }
    });
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-darkBlue via-darkerBlue to-darkBlue">
      {/* Header Section */}
      <div className="bg-darkerBlue/50 backdrop-blur-md sticky top-0 z-40 border-b border-primary/20">
        <div className="container max-w-6xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <h1 className="text-xl md:text-2xl font-bold text-primary">NEWS HACK</h1>
            <div className="flex items-center gap-2 text-sm">
              <FaLock className="text-primary" />
              <span className="text-white">Pembayaran Aman</span>
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-6xl mx-auto px-4 py-8">
        {/* Order Summary at the top */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-gradient-to-br from-primary/20 to-primaryDark/20 rounded-2xl p-6 border border-primary/30 mb-8 max-w-2xl mx-auto"
        >
          <h2 className="text-2xl font-bold text-white mb-6 text-center">Ringkasan Pesanan Anda</h2>
          
          <div className="grid md:grid-cols-2 gap-6">
            {/* Left side - Price breakdown */}
            <div className="space-y-4">
              <div className="flex justify-between">
                <span className="text-textGray">Webinar News Hack</span>
                <span className="text-white font-semibold">Rp 350.000</span>
              </div>
              <div className="flex justify-between text-green-400">
                <span>Diskon Spesial (71%)</span>
                <span>- Rp 250.000</span>
              </div>
              <div className="border-t border-primary/30 pt-4">
                <div className="flex justify-between">
                  <span className="text-lg font-bold text-white">Total</span>
                  <div className="text-right">
                    <span className="text-sm line-through text-gray-500 block">Rp 350.000</span>
                    <span className="text-2xl font-bold text-primary">Rp 100.000</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Right side - Benefits */}
            <div className="space-y-3">
              <h4 className="font-semibold text-white">Yang Anda Dapatkan:</h4>
              <div className="space-y-2 text-sm">
                <div className="flex items-start gap-2">
                  <FaCheckCircle className="text-green-400 mt-0.5 flex-shrink-0" />
                  <span className="text-textGray">Akses Webinar 2,5 Jam FULL</span>
                </div>
                <div className="flex items-start gap-2">
                  <FaCheckCircle className="text-green-400 mt-0.5 flex-shrink-0" />
                  <span className="text-textGray">GRATIS RE-SEAT Selamanya</span>
                </div>
                <div className="flex items-start gap-2">
                  <FaCheckCircle className="text-green-400 mt-0.5 flex-shrink-0" />
                  <span className="text-textGray">Rekaman Lifetime Access</span>
                </div>
                <div className="flex items-start gap-2">
                  <FaCheckCircle className="text-green-400 mt-0.5 flex-shrink-0" />
                  <span className="text-textGray">E-Book Bonus (Senilai 500rb)</span>
                </div>
              </div>
            </div>
          </div>

          {/* Timer */}
          <div className="bg-red-900/20 border border-red-500/30 rounded-lg p-4 mt-6">
            <div className="flex items-center gap-3 justify-center">
              <FaClock className="text-red-400 text-xl" />
              <div>
                <p className="text-sm text-red-400">Harga promo berakhir dalam:</p>
                <p className="text-xl font-bold text-white">
                  {String(timeLeft.hours).padStart(2, '0')}:
                  {String(timeLeft.minutes).padStart(2, '0')}:
                  {String(timeLeft.seconds).padStart(2, '0')}
                </p>
              </div>
            </div>
          </div>

          {/* Trust & Urgency */}
          <div className="mt-6 text-center space-y-3">
            <div className="flex items-center gap-2 text-sm text-textGray justify-center">
              <FaShieldAlt className="text-primary" />
              <span>100% Aman & Terpercaya</span>
            </div>
            <p className="text-sm text-yellow-400">
              ⚡ Hanya tersisa <span className="font-bold">17 kursi</span> dari 100!
            </p>
          </div>
        </motion.div>

        {/* Order Form at the bottom */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="bg-darkerBlue/30 rounded-2xl p-6 border border-primary/20 max-w-2xl mx-auto"
        >
          <h3 className="text-xl font-bold text-white mb-4 text-center">Form Pemesanan</h3>
          
          {/* OrderOnline Embed Code - v8.0.4 */}
          <div className="bg-white rounded-lg p-6">
            <div className="ooef">
                <form className="orderonline-embed-form" data-username="sekaliseumurhidup" data-product-slug="wnh-1" data-product-id="672cafbb1ecd5f44f50b4904" id="oo-embed-form-wnh-1-1192" data-origin="orderonline">
                    <div className="ooef-loader"><div aria-live="polite" role="status"><div>Loading...</div></div></div>
                </form>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Checkout;